import { GlForm, GlFormGroup, GlFormInput, GlButton } from '@gitlab/ui';
import { isUserEmail } from '~/lib/utils/forms';
import { I18N_EMAIL, I18N_CANCEL, I18N_EMAIL_INVALID } from '../constants';
export default {
    name: 'EmailForm',
    components: {
        GlForm,
        GlFormGroup,
        GlFormInput,
        GlButton
    },
    props: {
        error: {
            type: String,
            required: false,
            default: ''
        },
        formInfo: {
            type: String,
            required: false,
            default: undefined
        },
        submitText: {
            type: String,
            required: true
        }
    },
    emits: [
        'cancel',
        'submit-email'
    ],
    data () {
        return {
            email: '',
            submitted: false
        };
    },
    computed: {
        inputValidation () {
            return {
                state: !(this.submitted && this.invalidFeedback),
                message: this.invalidFeedback
            };
        },
        invalidFeedback () {
            if (!this.submitted) {
                return '';
            }
            if (!isUserEmail(this.email)) {
                return I18N_EMAIL_INVALID;
            }
            return this.error;
        }
    },
    watch: {
        email () {
            this.submitted = false;
        }
    },
    methods: {
        submit () {
            this.submitted = true;
            this.$emit('submit-email', this.email);
        }
    },
    i18n: {
        email: I18N_EMAIL,
        cancel: I18N_CANCEL
    }
};
